import { DispatchType } from '../../../@types/redux-types'
import { FlowInformation } from '../../../@types/flow-types'
import { SegmentationType } from '../../../@types/types'
import { getContactsLoad } from '../contacts/contacts'
import { updateFlowInformation } from '../../reducers/flow/flowFeature'

export const configureFlow = (flowInformation: FlowInformation) => async (dispatch: DispatchType) => {
  dispatch(updateFlowInformation(flowInformation))
  flowInformation.metaData.segmentation === SegmentationType.AGENT && (await getContactsLoad()(dispatch))
}
